

(function() {

  class Text {
    constructor(element) {
      if(!element || element.classList.contains('u-module--initialized')) return;

      element.classList.add('u-module--initialized');

      this.element = element;

      this.initResponsiveTables();
      this.setMobileFallback();
      this.resizer();
    }

    resizer() {
      window.addEventListener("resize", () => {
        this.initResponsiveTables();
        this.setMobileFallback();
      });
    }

    initResponsiveTables() {
      const tables = this.element.querySelectorAll('table:not(.u-content-table)');
      tables.forEach((item) => {
        const org_html = item.outerHTML;
        const new_html = `<div class="u-text__table-wrapper">${ org_html }</div>`;
        item.outerHTML = new_html;
      });
    }

    setMobileFallback() {
      const fallbacks = this.element.querySelectorAll('.u-text__table-fallback');
      fallbacks.forEach((item) => {
        if(item.previousElementSibling.classList.contains('u-text__table-wrapper')) {
          item.previousElementSibling.classList.add('u-text__table-wrapper--with-mobile-fallback');
        }
      });
    }
  }

  function initAll(parent) {
    const elements = parent.querySelectorAll('.u-text');

    for (const element of elements) {
      new Text(element)
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('overlay-content-ready', function () {
    initAll(document.querySelector('.u-overlay__content'));
  });

})();